import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDashedCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={9}
    fill="none"
    viewBox="0 0 9 9"
    {...props}
  >
    <circle
      cx={4.025}
      cy={4.025}
      r={3.375}
      stroke="#7F7F7F"
      strokeDasharray="1 2"
      strokeWidth={1.25}
    />
  </svg>
);
export default SvgDashedCircle;
